<app-error-card>
  @if (selectedDate()) {
    <h3 class="card-title">{{entityLabel()}} data for the selected reporting period <b>{{selectedDate()}}</b> is not available.</h3>
    <div>
      <div>Please return to the prior page or select a new date from the As of Date Dropdown.</div>
      <div>Click
        <a routerLinkActive="active" [routerLink]="backRoute()" [queryParams]="backQueryParams()"
          (click)="backClick.emit()" class="click-here-btn" data-cy="investorDashboardRedirect">here</a>
        to go back to the Investor dashboard.
      </div>
    </div>
  } @else {
    <h3 class="card-title">{{entityLabel()}} data is not available.</h3>
    <div>
      <div>Please return to the prior page or click
        <a routerLinkActive="active" [routerLink]="backRoute()" [queryParams]="backQueryParams()"
          (click)="backClick.emit()" class="click-here-btn" data-cy="investorDashboardRedirect">here</a>
        to go back to the Investor dashboard.
      </div>
    </div>
  }
</app-error-card>
